var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3075 2.59875C9.435 2.79 9.5625 2.98125 9.5625 3.1725C9.5625 3.36375 9.49875 3.555 9.3075 3.74625L6.94875 6.105V12.735C6.94875 12.9262 6.885 13.1175 6.69375 13.3088C6.5025 13.5 6.375 13.5 6.18375 13.5H5.80125C5.61 13.5 5.41875 13.4362 5.2275 13.245C5.03625 13.0538 4.9725 12.9263 4.9725 12.6713V9.86625H4.59V12.6713C4.59 12.8625 4.52625 13.0538 4.335 13.245C4.14375 13.4362 4.01625 13.5 3.76125 13.5H3.37875C3.1875 13.5 2.99625 13.4362 2.805 13.245C2.61375 13.0538 2.55 12.9263 2.55 12.6713V6.04125L0.255 3.6825C0.0637501 3.555 0 3.36375 0 3.1725C0 2.98125 0.0637501 2.79 0.255 2.59875C0.44625 2.4075 0.57375 2.34375 0.82875 2.34375C1.08375 2.34375 1.21125 2.4075 1.4025 2.59875L3.50625 4.7025H6.05625L8.22375 2.535C8.415 2.4075 8.60625 2.28 8.7975 2.28C8.98875 2.34375 9.18 2.4075 9.3075 2.59875ZM2.99625 2.535C2.99625 3.045 3.1875 3.4275 3.50625 3.81C3.825 4.1925 4.27125 4.32 4.78125 4.32C5.29125 4.32 5.67375 4.12875 6.05625 3.81C6.43875 3.49125 6.56625 3.045 6.56625 2.535C6.56625 2.025 6.375 1.6425 6.05625 1.26C5.7375 0.8775 5.29125 0.75 4.78125 0.75C4.27125 0.75 3.88875 0.94125 3.50625 1.26C3.12375 1.57875 2.99625 2.025 2.99625 2.535Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGm);
export default __webpack_public_path__ + "static/media/gm.7f47b904f4135e5f05896683f8192111.svg";
export { ForwardRef as ReactComponent };